import Hero from "@/components/home/Hero";
import ServicesOverview from "@/components/home/ServicesOverview";
import USPSection from "@/components/home/USPSection";
import AboutSection from "@/components/home/AboutSection";
import HomeFAQ from "@/components/home/HomeFAQ";
import CTASection from "@/components/home/CTASection";

const Index = () => {
  return (
    <>
      <Hero />
      <ServicesOverview />
      <USPSection />
      <AboutSection />
      <HomeFAQ />
      <CTASection />
    </>
  );
};

export default Index;

